import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { updateUriRef } from '../../../actions/filterActions';
import { decode64 } from '../../../utils/decode';
import { CURRENCY } from '../../SbSharedRefineMenu/sbSharedRefineMenuConstants';

// components
import { SbSharedRefineMenuInputRadio } from '../SbSharedRefineMenuInput/SbSharedRefineMenuInputRadio';

// Used just for identifying the `all` value, should never be set in the filter store.
function getAllUrlLabel(filterName) {
    return `all ${filterName}`;
}

const { all } = defineMessages({
    all: {
        id: 'sb.SbMobileRefineMenu.radioSelect.all',
        defaultMessage: `{filterName, select,
            location {Anywhere}
            categoryL2 {All {allLabel}}
            categoryL3 {All {allLabel}}
            categoryL4 {All {allLabel}}
            price {Any price}
            priceTrade {Any price}
            other {All}
        }`,
    },
});

function SbSharedRefineMenuRadioSelectComponent(props) {
    const {
        appliedFilterValues,
        valuesToShow,
        filterName,
        intl,
        canBeDismissed,
        allLabel,
        totalCount,
        currency,
        onUpdateUriRef,
        onChange = () => {},
    } = props;
    const appliedUrlLabel = appliedFilterValues?.[0]?.urlLabel;
    const valuesToShowCopy = [...valuesToShow];

    if (canBeDismissed && valuesToShow.length > 1) {
        valuesToShowCopy.unshift({
            displayName: intl.formatMessage(all, { filterName, allLabel }),
            urlLabel: getAllUrlLabel(filterName),
            checked: !appliedUrlLabel,
            count: totalCount || 0,
            linkReference: appliedFilterValues?.[0]?.linkReference,
            currency,
        });
    }

    return (
        <>
            {valuesToShowCopy.map(item => {
                const checked = item.checked || item.urlLabel === appliedUrlLabel;

                return (
                    <SbSharedRefineMenuInputRadio
                        key={item.urlLabel}
                        name={filterName}
                        value={item.urlLabel}
                        checked={checked}
                        link={item.link}
                        linkReference={item.linkReference}
                        linkable={item.linkable}
                        onChange={() => {
                            const { currency: itemCurrency, link, linkReference } = item || {};
                            let uriRef = decode64(linkReference) || link;

                            if (itemCurrency) {
                                uriRef = uriRef.replace(
                                    `{${CURRENCY}}`,
                                    itemCurrency.toLowerCase()
                                );
                            }
                            onChange();
                            onUpdateUriRef({ filterValue: item, uriRef });
                        }}
                        text={item.displayName}
                        count={item.count}
                        isHidden={item.isHidden}
                    />
                );
            })}
        </>
    );
}

SbSharedRefineMenuRadioSelectComponent.propTypes = {
    appliedFilterValues: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    valuesToShow: PropTypes.array.isRequired,
    onUpdateUriRef: PropTypes.func.isRequired,
    canBeDismissed: PropTypes.bool,
    intl: PropTypes.object.isRequired,
    allLabel: PropTypes.string,
    totalCount: PropTypes.number,
    currency: PropTypes.string,
    onChange: PropTypes.func,
};

export const SbSharedRefineMenuRadioSelect = connect(null, (dispatch, { filterName }) => ({
    onUpdateUriRef: ({ filterValue, uriRef }) =>
        dispatch(updateUriRef({ filterName, filterValue, uriRef })),
}))(injectIntl(SbSharedRefineMenuRadioSelectComponent));
